// import firebase from "firebase/app";
// import "firebase/auth";
// // import "firebase/analytics";

// var app = firebase.initializeApp({
//   apiKey: "AIzaSyDcUnsMwKCtAi5dzrLDrW6uNYrNWt1aeUQ",
//   authDomain: "tellytell-236a3.firebaseapp.com",
//   projectId: "tellytell-236a3",
//   storageBucket: "tellytell-236a3.appspot.com",
//   messagingSenderId: "960438802371",
//   appId: "1:960438802371:web:b731497c7f470db8490f76",
//   measurementId: "G-EDQ1DTB61Z",
// });
// // Initialize Firebase
// export const auth =app.auth();
// export const GoogleProvider =new firebase.auth.GoogleAuthProvider()
// export default app;
// firebase.analytics();

// Import necessary modules from Firebase
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDcUnsMwKCtAi5dzrLDrW6uNYrNWt1aeUQ",
  authDomain: "tellytell-236a3.firebaseapp.com",
  projectId: "tellytell-236a3",
  storageBucket: "tellytell-236a3.appspot.com",
  messagingSenderId: "960438802371",
  appId: "1:960438802371:web:b731497c7f470db8490f76",
  measurementId: "G-EDQ1DTB61Z",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Authentication setup
export const auth = getAuth(app);
export const GoogleProvider = new GoogleAuthProvider();
export default app;
